module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "cont"
    }
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/prologue#prologue"
    }
  }, [_vm._v("Prologue: Sometimes You Just Have to Go for Broke")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("Chapter 1: Grin and Bear It")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Smile through the Pain")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Be Cute and Quick")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Get Up to the Net")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: It’s All in the Details")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Never Let Them See You Sweat")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Kill Them with Kindness")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Practice Grace under Pressure")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Never Keep a Lady Waiting")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Better to Be Overdressed Than Underdressed")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Sticks and Stones Can Break Your Bones")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Gossip Is an Unladylike Endeavor")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Mother Knows Best?")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: You Catch More Flies with Honey Than Vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Put On a Brave Face")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Boys Will Be Boys")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: If Life Gives You Lemons, Make Lemonade")]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('p', {
    staticClass: "conta"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Keep Your Friends Close and Your Enemies Closer")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: If It Walks Like a Duck, It’s Probably a Duck")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Pick Your Battles and Fight Them")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Never Forget Where You Came From")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Make an Entrance")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcc34e18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cont.vue
// module id = 87
// module chunks = 0